import { faIcon } from "@utils/faIcon"

import { EmptyState } from "@molecules"

import useObjectsView from "@organisms/ObjectsView/ObjectsView.context"
import styles from "@organisms/ObjectsView/TableView/TableViewEdgeStates/TableViewEdgeStates.module.scss"
import TableViewLoadingState, {
    GRAPHIC_ROWS_COUNT,
} from "@organisms/ObjectsView/TableView/TableViewEdgeStates/TableViewLoadingState/TableViewLoadingState"

import { TableViewErrorStateProps } from "./TableViewErrorState.types"

export default function TableViewErrorState(props: TableViewErrorStateProps) {
    const { children } = props

    const { refetch } = useObjectsView()

    return (
        <>
            {children}
            <div className={styles.base}>
                <TableViewLoadingState isAnimated={false} isBackground={true} numberOfRows={GRAPHIC_ROWS_COUNT} />
                <EmptyState
                    variant="error"
                    icon={faIcon({ name: "circle-xmark", style: "solid" })}
                    title="Hmm, something went wrong"
                    supportText="An error occurred while fetching data"
                    primaryCTA={{
                        children: "Reload",
                        leftIcon: faIcon({ name: "refresh", style: "regular" }),
                        onClick: () => void refetch(),
                    }}
                />
            </div>
        </>
    )
}
